import TextCurrency from '@atoms/TextCurrency';
import { Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface WithdrawalAmountProps {
  requestedAmount?: number;
}

const WithdrawalAmount: React.FC<WithdrawalAmountProps> = ({ requestedAmount = 0 }) => {
  const { t } = useTranslation('common');
  return (
    <View style={appStyles.amountContainer}>
      <Text testID="lblAmountOfWithdrawal" variant="lg-normal" flex={1}>
        {t('withdrawalPage.amountOfWithdrawal')}
      </Text>
      <TextCurrency variant="sm-bold" amountCurrency={requestedAmount || 0} showCurrencySymbol />
    </View>
  );
};

export default WithdrawalAmount;
